<template>
  <el-dialog
    title="续费支付"
    :visible.sync="visible"
    width="800px"
    custom-class="normal-dialog full-dialog"
    :before-close="() => (visible = false)"
    :close-on-click-modal="false"
  >
    <div class="course-renew-dialog">
      <course-creater-pay-pane
        v-if="productDetail"
        :productDetail="productDetail"
        @paySuccess="orderId => confirmHandle(orderId)"
      >
        <div>
          <span>支付成功之后，将会激活 </span>
          <span :style="{ color: '#1991fb' }">{{ detail._source.title }}</span>
          <span> 课题</span>
        </div>
      </course-creater-pay-pane>
    </div>
  </el-dialog>
</template>

<script>
import courseCreaterPayPane from '@/components/courseCreater/courseCreaterPayPane';

import { services } from '@/service';
import { formatProductInfo } from '@/lib/utils';

export default {
  components: { courseCreaterPayPane },
  data() {
    return {
      loading: false,
      productDetail: null
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      required: true
    }
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      }
    }
  },
  async mounted() {
    try {
      this.loading = true;
      const { data } = await services.originCase.getRenewProduct(this.detail._id);
      this.productDetail = formatProductInfo(data);
    } catch (err) {
      this.$error(err);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async confirmHandle(orderId) {
      try {
        this.loading = true;
        await services.originCase.renewCourse(this.detail._id, orderId);
        this.$emit('success', orderId);
        this.visible = false;
      } catch (err) {
        this.$error(err);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.course-renew-dialog {
  min-height: 300px;
}
</style>
